import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { getReportsPDF } from "apis";
import { IChild } from "types";

interface Props {
  open: boolean;
  onClose: () => void;
  item: Report;
}

type Report = {
  id: number;
  child: IChild;
  path: string;
  createdAt: string;
  comment: string;
};

const ViewReportDialog: React.FC<Props> = ({ open, onClose, item }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState<string>("");

  useEffect(() => {
    getReportsPDF({ id: item.id }).then((data) => {
      setValue(data);
    });
  }, []);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{t("report.view")}</DialogTitle>

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <embed
          src={`data:application/pdf;base64,${value}`}
          width="100%"
          height={720}
          type="application/pdf"
        />
      </DialogContent>
    </Dialog>
  );
};

export default ViewReportDialog;
